import type { PatientIdentity } from '@/types/api';

/** "Petar (Marko) Petrović": first name, one parent's name, last name, as Serbian records write it. */
export function patientFullName(p: Pick<PatientIdentity, 'firstName' | 'lastName' | 'parentName'>) {
  return [p.firstName, p.parentName ? `(${p.parentName})` : null, p.lastName]
    .filter(Boolean)
    .join(' ');
}
